import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.t4k_1.a4g($this.s4k_1.t4i());
  $this.u4k_1 = add($this.u4k_1, appended);
}
function updateConsumed($this) {
  $this.v4k_1 = add($this.v4k_1, subtract($this.u4k_1, $this.t4k_1.q2()));
  $this.u4k_1 = $this.t4k_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.s4k_1 = delegate;
        this.t4k_1 = new (Buffer())();
        this.u4k_1 = 0n;
        this.v4k_1 = 0n;
      }
      w4k() {
        updateConsumed(this);
        return this.v4k_1;
      }
      y4i() {
        return this.s4k_1.y4i();
      }
      a4j() {
        return this.t4k_1.s3x() && this.s4k_1.a4j();
      }
      t4i() {
        transferFromDelegate(this);
        return this.t4k_1;
      }
      *b4j(min, $completion) {
        if (this.t4i().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.s4k_1.b4j(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      l4j(cause) {
        this.s4k_1.l4j(cause);
        this.t4k_1.l6();
      }
    }
    protoOf($).h4j = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
